import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contaxt/AuthContext";
import Footer from "@/components/Footer";
import "../styles/globle.css";

const PaymentCanceled = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  const handleNavigation = () => {
    if (isAuthenticated) {
      navigate("/plans");
    } else {
      navigate("/plans");
    }
  };

  return (
    <div className="login-container">
      {/* MAIN SECTION – identical layout to Login */}
      <div className="flex items-center justify-center w-full px-4 pt-12 pb-24 md:pt-16 md:pb-32">
        {/* CARD – EXACT SAME CLASSNAMES AS LOGIN */}
        <Card className="w-full max-w-md p-8 rounded-2xl shadow-sm">
          {/* Keep CardContent clean like Login and style inside */}
          <CardContent>
            <div className="text-center space-y-6">
              {/* Icon */}
              <div className="text-6xl">😔</div>

              {/* Heading + Subtext */}
              <div className="space-y-2">
                <h2 className="text-2xl font-bold text-gray-900">
                  Payment was not completed
                </h2>
                <p className="text-base text-gray-600">
                  No worries, you can still unlock your exam results by returning below.
                </p>
              </div>

              {/* CTA – same height / style as Login CTA */}
              <Button
                onClick={handleNavigation}
                className="
                  w-full h-11
                  text-base font-medium rounded-lg
                  bg-[#005FCC] hover:bg-[#0049A8]
                  text-white transition-colors
                "
              >
                {isAuthenticated ? "Return to Plans" : "Return to Plans"}
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>

      {/* FOOTER – same wrapper as Login */}
      <div className="footer-container-login">
        <Footer />
      </div>
    </div>
  );
};

export default PaymentCanceled;
